import { Typography } from "@material-ui/core";
import { getNonEmpty } from "../../../../utils/helpers";
import { InfoItem } from "../contacts/WatchContactPage";
import { DefaultTextField } from "../customers/EditCustomerPage";


export default function GeneralTab({ project, setProject }) {

    const SolarValue = ({ tech }) => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">

                    <Typography variant="h6" color="text.secondary">
                        Solar Technology
                    </Typography>
                    <Typography style={{
                        marginBottom: '16px',
                        color: 'rgba(61, 60, 60, 0.38)',
                        opacity: 1
                    }}>
                        {tech?.techType || '---'}
                    </Typography>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-2">
                        <InfoItem label="DC Power: " value={tech?.dcPower + ' MWp'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="AC Power: " value={tech?.acPower + ' MW'} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Annual Energy Production: " value={tech?.anualEnergyProd + ' MWh'} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Specific Yield P50: " value={tech?.capacityP50 + ' kWh/kWp/year'} h6 row />
                    </div>
                </div>
            </>
        );
    }

    const StorageValue = ({ tech }) => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Storage Technology
                    </Typography>
                    <Typography style={{
                        marginBottom: '16px',
                        color: 'rgba(61, 60, 60, 0.38)',
                        opacity: 1
                    }}>
                        {tech?.techType || '---'}
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-2">
                        <InfoItem label="AC Power: " value={tech?.acPower + ' MW'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="Energy Capacity: " value={tech?.anualEnergyProd + ' MWh'} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Energy Storage duration: " value={tech?.storeDuration + ' h'} h6 row />
                    </div>
                </div>
            </>
        );
    }

    const WindValue = ({ tech }) => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Wind Technology
                    </Typography>
                    <Typography style={{
                        marginBottom: '16px',
                        color: 'rgba(61, 60, 60, 0.38)',
                        opacity: 1
                    }}>
                        {tech?.techType || '---'}
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-2">
                        <InfoItem label="AC Power: " value={tech?.power + ' MW'} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Annual Energy Production: " value={tech?.anualEnergyProd + ' MWh'} h6 row />
                    </div>
                </div>
            </>
        );
    }

    const HydrogenValue = ({ tech }) => {
        return (
            <>
                <div className="d-flex align-item-center mt-5 flex-column">
                    <Typography variant="h6" color="text.secondary">
                        Hydrogen Technology
                    </Typography>
                    <Typography style={{
                        marginBottom: '16px',
                        color: 'rgba(61, 60, 60, 0.38)',
                        opacity: 1
                    }}>
                        {tech?.techType || '---'}
                    </Typography>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-2">
                        <InfoItem label="Power: " value={tech?.power + ' MWe'} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Annual Energy Production: " value={tech?.anualEnergyProd + ' MWh'} h6 row />
                    </div>
                </div>
            </>
        );
    }


    return (

        <>

            <div className="d-flex align-item-center">
                <div className="col-4">
                    <InfoItem label="Title" value={project?.title} />
                </div>
                <div className="col-4" />
                <div className="col-4">
                    <InfoItem label="Seller" value={project?.seller?.fullName} />
                </div>
            </div>

            <div className="d-flex align-item-center">
                <div className="col-12">
                    {project?.status !== "review" ?
                        <InfoItem label="Description" value={project?.description} />
                        : (
                            <>
                                <Typography variant={"h6"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                                    Description
                                </Typography>

                                <DefaultTextField value={project?.description}
                                    onChange={(e) => {
                                        setProject({
                                            ...project,
                                            description: e.target.value
                                        });
                                    }}
                                    required={false} multiline rows={4}
                                />
                            </>
                        )
                    }
                </div>
            </div>
            <div className="d-flex align-item-center">
                <div className="col-3">
                    <InfoItem label="Country" value={project?.country?.name} />
                </div>
                <div className="col-3">
                    <InfoItem label="Province" value={project?.province} />
                </div>
                <div className="col-3">
                    <InfoItem label="City" value={project?.city} />
                </div>
            </div>

            <div className="d-flex align-item-center">
                <div className="col-3">
                    <InfoItem label="RTB expected Date" value={project?.rtbDate} />
                </div>
                <div className="col-3">
                    <InfoItem label="COD expected Date" value={project?.codDate} />
                </div>
                <div className="col-3">
                    <InfoItem label="Development status" value={getNonEmpty(project?.developmentStatus)} />
                </div>
                <div className="col-3">
                    <InfoItem label="Target Price (k€/MW)" value={project?.targetPrice} />
                </div>
            </div>

            <div className="d-flex align-item-center">
                <div className="col-4">
                    <InfoItem label="Technologies" value={project?.technology?.map((tech) => getNonEmpty(tech?.id?.title)).join(", ")} />
                </div>
            </div>

            {project?.technology?.some(tech => tech?.type?.toLowerCase() === "solar") && <SolarValue tech={project?.technology?.find(tech => tech?.type?.toLowerCase() === "solar")} />}
            {project?.technology?.some(tech => tech?.type?.toLowerCase() === "storage") && <StorageValue tech={project?.technology?.find(tech => tech?.type?.toLowerCase() === "storage")} />}
            {project?.technology?.some(tech => tech.type.toLowerCase() === "wind") && <WindValue tech={project?.technology?.find(tech => tech?.type?.toLowerCase() === "wind")} />}
            {project?.technology?.some(tech => tech.type.toLowerCase().includes("hydrogen")) && <HydrogenValue tech={project?.technology?.find(tech => tech.type.toLowerCase().includes("hydrogen"))} />}

        </>
    )

}